import { Fragment, useState } from "react";
import { useAsync } from "react-async";
import { DashboardProps, DashboardPropsDefaults } from "../../types/dashboardProps.d";
import { getDistrictsCount } from "../../../../api/services/districtService";
import { getDisciplineTherapists } from "../../../../api/services/disciplineService";
import DisciplineTherapists from '../../../../api/models/disciplineTherapists';
import DisciplineUsers from "../../../../api/models/disciplineUsers";
import { Link, useHistory } from "react-router-dom";
import Spinner from "../../../spinner";
import { sortUsersByDiscipline } from "../../../../common/utils";

const DashboardWidgetDirectorGeneral = ({ user }: DashboardProps): JSX.Element => {
    const [districtsCount, setDistrictsCount] = useState<number>(0);
    const [disciplineTherapists, setDisciplineTherapists] = useState<DisciplineTherapists>();
    const [disciplineUsers, setDisciplineUsers] = useState<DisciplineUsers[]>([]);
    const [totalActiveTherapists, setTotalActiveTherapists] = useState<number>(0);
    const history = useHistory();

    const asyncDistrictsCount = useAsync({
        promiseFn: getDistrictsCount,
        onResolve: (r) => setDistrictsCount(r.data)
    });

    const asyncDisciplineTherapists = useAsync({
        promiseFn: getDisciplineTherapists,
        onResolve: (response) => {
            const disciplineTherapists: DisciplineTherapists = response;
            const sorted: DisciplineUsers[] = sortUsersByDiscipline(disciplineTherapists);
            setDisciplineTherapists(disciplineTherapists);
            setDisciplineUsers(sorted);

            //Set total active therapists
            let totalActive = 0;
            sorted.map((du: DisciplineUsers, i: number) => totalActive += du.users.length);
            setTotalActiveTherapists(totalActive);
        }
    });

    return (
        <div className={`${DashboardPropsDefaults.containerClassNames}`}>
            <div className="pb-1 dashboard-widget-title">
                <h3>General Information</h3>
            </div>
            <div className={`${DashboardPropsDefaults.contentClassNames}`}>
                <Spinner show={(asyncDistrictsCount.isPending || asyncDisciplineTherapists.isPending)} />
                {!(asyncDistrictsCount.isPending || asyncDisciplineTherapists.isPending) && (
                    <>
                        <div>
                            {districtsCount && (
                                <div className={`mb-2 font-bold`}>All Active Districts: <Link to={`/admin/districts`}>({districtsCount})</Link></div>
                            )}
                        </div>
                        <div>
                            {disciplineTherapists !== undefined && (<>
                                {disciplineTherapists.therapists.length > 0 && (
                                    <div className={`mb-2 font-bold`}>
                                        Total Active Therapists: <Link to={`/admin/therapists`}>({totalActiveTherapists})</Link>
                                    </div>
                                )}
                            </>)}
                        </div>
                        <div className={`mb-2 mt-2`}>
                            <h3 className="mb-1 text-sm font-bold">Disciplines:</h3>
                            {disciplineUsers.map((du: DisciplineUsers, i: number) => {
                                return du.users.length > 0 ?
                                    <div key={`du-${i}`}>
                                        <h3 className="mb-1 text-xs">
                                            {du.discipline.name}&nbsp;
                                            (<span className="underline cursor-pointer hover:no-underline"
                                                onClick={() => history.push('/admin/therapists', { discipline: du.discipline }
                                                )}>{du.users.length}</span>)
                                        </h3>
                                    </div>
                                    : <Fragment key={`du-${i}`}></Fragment>;
                            })}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default DashboardWidgetDirectorGeneral;
